import { ListingResponse } from './listing-response';
import { Metadata } from './metadata';
import { ValidateListingResponse } from './validate-listing-response';
import { ValidationResult } from './validation-result';

export interface Draft {
    id: number;
    categoryId: number;
    status: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    draftData: any;
    originalDraftData?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validationSchema: any;
    metadata: Metadata;
    validationResults: ValidationResult[];
    validateListingResponse: ValidateListingResponse;
    listingResponse: ListingResponse;
}
